import styled from "styled-components";

export const TermsConditions = styled.p`
    text-align: justify;
`
